import React from "react";
import classnames from "classnames";
import { SMALL } from "Shared/breakpoints";
import { viewLayoutTypes } from "Shared/ViewLayoutSelection";
import { translate } from "Shared/translate";
import { urlToString } from "Shared/url";
import { searchPageUrl } from "Shared/known-urls";
import * as styles from "./autocomplete.scss";
import MyMenigoIcon from "../../../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon";
import DidYouMean from "./DidYouMean";
import InfoBlock from "./InfoBlock";
import ProductCardsGrid from "Shared/ProductCard/ProductRow2.0/ProductCardsGrid";
import { setSessionStorageGa4SearchTrackedFlag } from "../../../../../TrackingInformation";
import { pushState } from "Shared/history";
const ProductSearchList = (props) => {
    const isMobile = props.currentBreakpoint <= SMALL;
    const linkTo = (e) => {
        if (e.ctrlKey) {
            return true;
        }
        if (!!props.searchTerm) {
            e.preventDefault();
            const url = urlToString({
                path: searchPageUrl().url,
                query: { q: props.searchTerm },
            });
            setSessionStorageGa4SearchTrackedFlag("false");
            pushState(url);
        }
    };
    return (React.createElement(React.Fragment, null, props.lists.map((list, index) => list.products && list.products.length > 0 ? (React.createElement("div", { key: "ProductCardList" + index },
        React.createElement("h4", { className: styles.listHeader },
            translate("/ProductListing/CustomFilterShows"),
            " ",
            !!props.totalItems && (React.createElement("span", null,
                "(",
                props.totalItems,
                " ",
                translate("/Units/UnitShortNames/st"),
                ")")),
            " "),
        React.createElement(ProductCardsGrid, { products: list.products, viewLayoutType: viewLayoutTypes.list.name, searchTerm: props.searchTerm, viewItemListEvent: list.viewItemListEvent, addToCartLocation: "QuickSearch" }),
        React.createElement("a", { className: classnames(styles.button, styles.showAll), href: urlToString({
                path: searchPageUrl().url,
                query: { q: props.searchTerm },
            }), onClick: (e) => linkTo(e), "data-may-prevent-default": true },
            list.products.length == 1
                ? translate("/Shared/Show")
                : translate("/Shared/ShowAll"),
            React.createElement(MyMenigoIcon, { name: "arrow" })))) : list.products &&
        props.searchTerm.length > 1 &&
        !!list.searchDidYouMean &&
        list.searchDidYouMean.length > 0 ? (React.createElement(React.Fragment, { key: "DidYouMean-HelpText" },
        React.createElement("div", { className: classnames(styles.noHitsSection, {
                [styles.searchSuggestionBackgroundBox]: isMobile,
            }) },
            React.createElement("div", { className: classnames({
                    [styles.searchSuggestionBox]: isMobile,
                }) },
                React.createElement(DidYouMean, null))),
        React.createElement("div", { className: classnames(styles.infoBlock, {
                [styles.searchSuggestionBackgroundBox]: !isMobile,
            }) },
            React.createElement(InfoBlock, { helpText: props.helpText, helpTextChat: props.helpTextChat })))) : (list.products &&
        props.searchTerm.length > 1 && (React.createElement(React.Fragment, { key: "NoResult-HelpText" },
        React.createElement("div", { className: classnames(styles.noHitsSection, {
                [styles.searchSuggestionBackgroundBox]: isMobile,
            }) },
            React.createElement("div", { className: classnames({
                    [styles.searchSuggestionBox]: isMobile,
                }) }, `${translate("/Shared/FadeNoHits")}`)),
        React.createElement("div", { className: classnames(styles.infoBlock, {
                [styles.searchSuggestionBackgroundBox]: !isMobile,
            }) },
            React.createElement(InfoBlock, { helpText: props.helpText, helpTextChat: props.helpTextChat }))))))));
};
export default ProductSearchList;
